import type { i18n as I18nInstance } from "i18next";
import { normalizeLocaleLanguage } from "@/constants/localization";

/**
 * Minimal WebVTT payload used when no transcript exists.
 * Satisfies jsx-a11y/media-has-caption for audio/video elements without captions.
 */
export const EMPTY_CAPTIONS_TRACK_SRC = "data:text/vtt,WEBVTT";

/** BCP-47 language for <track srcLang>, aligned with the active UI locale. */
export const getMediaTrackSrcLang = (i18n: I18nInstance): string =>
  normalizeLocaleLanguage(i18n?.resolvedLanguage || i18n?.language || "en");
